import { put } from "typed-redux-saga";
import { takeEveryFsa } from "../operations";
import { appActions } from "./actions";

export function* appSaga() {
    yield takeEveryFsa(appActions.init.started, function* (action) {
        yield put(appActions.init.done({ params: action.payload, result: {} }));
    })
}